import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Play, Pause, Sparkles } from "lucide-react";

const SAMPLES = [
  { slug: "robs",   name: "robS",   gender: "Maschile",  desc: "La tua voce clonata (Instant Cloning)",                  voiceId: "huNktiJW6VSuTcLGvH0s", special: true },
  { slug: "danilo", name: "Danilo", gender: "Maschile",  desc: "Italiano nativo · Conversazionale",                       voiceId: "4YsN90HrCPrOCmBglwMA" },
  { slug: "brando", name: "Brando", gender: "Maschile",  desc: "Italiano nativo · Conversazionale",                       voiceId: "o4b57JYAECRMJyCEXyIE" },
  { slug: "carla",  name: "Carla",  gender: "Femminile", desc: "Italiana nativa · Conversazionale",                       voiceId: "litDcG1avVppv4R90BLu" },
  { slug: "giusy",  name: "Giusy",  gender: "Femminile", desc: "Italiana nativa · Conversazionale",                       voiceId: "8KInRSd4DtD5L5gK7itu" },
];

export default function Audizione() {
  const [playing, setPlaying] = useState(null);
  const audioRef = useRef(null);

  const togglePlay = (slug) => {
    if (playing === slug) {
      audioRef.current?.pause();
      setPlaying(null);
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
      }
      const audio = new Audio(`/voice_samples/${slug}.mp3?v=${Date.now()}`);
      audioRef.current = audio;
      audio.onended = () => setPlaying(null);
      audio.play();
      setPlaying(slug);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg" data-testid="audizione-page">
      <header className="border-b border-brand-line bg-white/60 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-brand-inkSoft hover:text-brand-ink transition">
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Indietro</span>
          </Link>
          <span className="font-heading text-lg text-brand-ink">Audizione 24Vox · v2</span>
          <div className="w-16"></div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <p className="text-xs font-medium tracking-[0.25em] text-brand-terra uppercase mb-4">Audizione voci italiane native</p>
        <h1 className="font-heading text-4xl md:text-5xl text-brand-ink mb-4 leading-tight">
          Ora siamo seri.
        </h1>
        <p className="text-lg text-brand-inkSoft mb-10 max-w-2xl">
          5 voci dalla Voice Library + <strong className="text-brand-terra">la tua voce clonata</strong>. Stesso identico saluto. Ascolta tutto, poi mi dici le 2 finaliste (1M + 1F).
        </p>

        <div className="bg-brand-bg2 border border-brand-line rounded-xl p-5 mb-10 italic text-brand-inkSoft text-sm">
          "Pronto, Tenuta Ciminata Greco, sono l'assistente vocale di 24Vox. Il titolare ora non può rispondere, ma posso aiutarti io con le prime informazioni. Come posso esserti utile?"
        </div>

        <div className="space-y-4">
          {SAMPLES.map((v) => (
            <div
              key={v.slug}
              className={`bg-white border rounded-xl p-5 flex items-center gap-4 hover:shadow-md transition-shadow ${
                v.special ? "border-brand-terra border-2 ring-4 ring-brand-terra/10" : "border-brand-line"
              }`}
            >
              <button
                onClick={() => togglePlay(v.slug)}
                className={`w-16 h-16 rounded-full flex items-center justify-center transition shrink-0 ${
                  playing === v.slug ? "bg-brand-terra text-white" : "bg-brand-olive text-brand-bg hover:bg-brand-oliveDark"
                }`}
                data-testid={`play-${v.slug}`}
              >
                {playing === v.slug ? <Pause className="w-6 h-6" /> : <Play className="w-6 h-6 ml-0.5" />}
              </button>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="font-heading text-2xl text-brand-ink">{v.name}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-brand-bg2 text-brand-inkSoft">{v.gender}</span>
                  {v.special && (
                    <span className="flex items-center gap-1 text-xs px-2 py-0.5 rounded-full bg-brand-terra text-white">
                      <Sparkles className="w-3 h-3" />
                      LA TUA VOCE
                    </span>
                  )}
                </div>
                <p className="text-sm text-brand-inkSoft">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-brand-olive/5 border border-brand-olive/20 rounded-2xl p-6">
          <h2 className="font-heading text-2xl text-brand-ink mb-3">Cosa fai adesso</h2>
          <ol className="space-y-2 text-brand-ink">
            <li><strong>1.</strong> Ascolta tutte e 5 le voci (la prima è la tua!)</li>
            <li><strong>2.</strong> Dimmi le 2 finaliste: <em>"Maschile = robS / Danilo / Brando"</em> + <em>"Femminile = Carla / Giusy"</em></li>
            <li><strong>3.</strong> Le imposto come default di 24Vox + le rendo selezionabili dal cliente nel form</li>
          </ol>
          <p className="text-sm text-brand-inkSoft mt-4 italic">
            💡 Suggerimento: ascolta robS per ultimo. Saprà la magia o l'imbarazzo del cloning Instant. Se la qualità è 70%+, conviene rifare con Professional Voice Cloning (3-7 giorni, 95% qualità).
          </p>
        </div>
      </main>
    </div>
  );
}
